import React from 'react';

import {SampleDetails} from 'constants/SampleConstants';
import {SampleFilter} from 'notebook/sample-propagation/SampleFilter';
import getSampleDescriptor from 'notebook/sample-propagation/util/getSampleDescriptor';

import LegacyAddSamplesModal, {LegacySamplesSource} from './LegacyAddSamplesModal';

export interface AddStandaloneSamplesModalProps {
  onRequestClose: () => void;
  onSamplesSelected: (samples: Array<SampleDetails>) => void;
  sources: Array<LegacySamplesSource> | null;
  title?: string;
  sampleType?: SampleFilter;
}

export const AddStandaloneSamplesModal: React.FunctionComponent<AddStandaloneSamplesModalProps> = (
  props: AddStandaloneSamplesModalProps
) => {
  const descriptor = getSampleDescriptor(props.sampleType);
  return (
    <LegacyAddSamplesModal
      title={props.title || `Add ${descriptor.plural}`}
      enableRowCounts={false}
      sources={props.sources}
      onSamplesSelected={props.onSamplesSelected}
      onRequestClose={props.onRequestClose}
      samplesHaveStageRuns={false}
      sampleDescriptor={descriptor}
    />
  );
};
